<template>
  <section
    class="lp-testimonials"
    :style="{
      backgroundColor: section.styles.backgroundColor || '#f1f5f3',
      padding: section.styles.padding || '5rem 1.25rem',
      textAlign: section.styles.textAlign || 'center',
    }"
  >
    <div class="max-w-5xl mx-auto">
      <h2 v-if="section.content.title" class="lp-testimonials__title">{{ section.content.title }}</h2>
      <div class="lp-testimonials__grid">
        <blockquote
          v-for="(item, index) in section.content.items || []"
          :key="index"
          class="lp-quote"
        >
          <p class="lp-quote__text">“{{ item.quote }}”</p>
          <footer class="lp-quote__footer">
            <div class="lp-quote__author">{{ item.author }}</div>
            <div class="lp-quote__role">{{ item.role }}</div>
          </footer>
        </blockquote>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    section: { type: Object, required: true },
    preview: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.lp-testimonials__title {
  font-family: var(--ps-font-display);
  font-size: clamp(1.75rem, 3vw, 2.35rem);
  font-weight: 700;
  letter-spacing: -0.03em;
  color: #0f172a;
  margin-bottom: 2.5rem;
}

.lp-testimonials__grid {
  display: grid;
  gap: 1.5rem;
}

@media (min-width: 768px) {
  .lp-testimonials__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 2rem;
  }
}

.lp-quote {
  text-align: left;
  padding: 0.25rem 0.15rem 0.25rem 1.15rem;
  border-left: 3px solid var(--lp-primary-color, #0f766e);
}

.lp-quote__text {
  color: #334155;
  line-height: 1.65;
  font-size: 1.05rem;
  margin-bottom: 1rem;
  font-style: italic;
}

.lp-quote__author {
  font-weight: 700;
  color: #0f172a;
  font-size: 0.95rem;
}

.lp-quote__role {
  color: #64748b;
  font-size: 0.85rem;
  margin-top: 0.15rem;
}
</style>
